import "./newToll.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { useSelector } from "react-redux";

const NewToll = ({ title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const { state } = useLocation();
  const tollData = state?.toll || {};

  const [formData, setFormData] = useState({
    userId: tollData.userId || userIdRedux,
    tollName: tollData.tollName || "",
    penaltyAmount: tollData.penaltyAmount || "",
    email: tollData.email || "",
    password: tollData.password || "",
  });

  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errs = {};
    if (!formData.tollName.trim()) errs.tollName = "Toll Name is required.";
    if (!formData.penaltyAmount)
      errs.penaltyAmount = "Penalty Amount is required.";
    else if (!/^\d+$/.test(formData.penaltyAmount))
      errs.penaltyAmount = "Must be a valid number";
    if (!formData.email.trim()) errs.email = "Email is required.";
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email))
      errs.email = "Invalid email format.";
    if (!formData.password) errs.password = "Password is required.";
    else if (formData.password.length < 8)
      errs.password = "Password must be at least 8 characters.";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    // Convert penaltyAmount to number
    const payload = {
      ...formData,
      penaltyAmount: Number(formData.penaltyAmount),
    };

    const url = tollData._id
      ? `${BASE_URL}/api/tollName/updateTollName/${tollData._id}`
      : `${BASE_URL}/api/tollName/addTollName`;

    try {
      const response = tollData._id
        ? await axios.put(url, payload)
        : await axios.post(url, payload);

      if (response.status === 200 || response.status === 201) {
        navigate("/toll");
      }
    } catch (err) {
      const msg =
        err.response?.data?.msg ||
        err.response?.data?.message ||
        "Something went wrong";
      setBackEndError(msg);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{ display: "grid", gap: "1rem", width: "100%" }}
          >
            <TextField
              name="tollName"
              label="Toll Name"
              value={formData.tollName}
              onChange={handleChange}
              error={!!errors.tollName}
              helperText={errors.tollName}
              fullWidth
              required
            />
            <TextField
              name="penaltyAmount"
              label="Penalty Amount"
              type="number"
              value={formData.penaltyAmount}
              onChange={handleChange}
              error={!!errors.penaltyAmount}
              helperText={errors.penaltyAmount}
              fullWidth
              required
            />
            <TextField
              name="email"
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
              fullWidth
              required
            />
            <TextField
              name="password"
              label="Password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              error={!!errors.password}
              helperText={errors.password}
              fullWidth
              required
            />
            <span className="error-message" style={{ color: "red" }}>
              {backEndError}
            </span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewToll;
